import { createFeatureSelector } from '@ngrx/store';

export const historyOrdersState = createFeatureSelector<OLO.State, OLO.State.HistoryOrders>('historyOrders');
